import type { Resource } from '../../';
export const header_utilBar_cartIconAltText: Resource = {"default":"View Cart Page"};
